import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'rr_preview';
let _promise = null;
let _promiseKey;

// Sign-off preview: ?preview= on the register (or ?rr_preview= anywhere) is remembered for the session.
export const rememberRegisterPreview = (token) => { if (token) sessionStorage.setItem(KEY, token); };
export const previewToken = () => {
  const qp = new URLSearchParams(window.location.search).get('rr_preview');
  if (qp) sessionStorage.setItem(KEY, qp);
  return sessionStorage.getItem(KEY) || undefined;
};

export function useReviewBadges() {
  const [b, setB] = useState({ suppliers: {}, products: {} });
  useEffect(() => {
    const tok = previewToken();
    if (!_promise || _promiseKey !== tok) {
      _promiseKey = tok;
      _promise = axios.get(`${API}/public/review-register/badges`, { params: { preview: tok } })
        .then((r) => r.data).catch(() => ({ suppliers: {}, products: {} }));
    }
    let on = true;
    _promise.then((d) => on && setB(d));
    return () => { on = false; };
  }, []);
  return b;
}

const href = (badge) => {
  const p = sessionStorage.getItem(KEY);
  return `/independently-reviewed?ref=${encodeURIComponent(badge.ref)}${p ? `&preview=${encodeURIComponent(p)}` : ''}`;
};

// "CTC independently reviewed" badge; `small` for directory cards (rendered as a span - cards are links).
export default function ReviewBadge({ badge, small = false, testid }) {
  const navigate = useNavigate();
  if (!badge) return null;
  const dot = badge.status === 'amber' ? 'bg-amber-400' : 'bg-emerald-500';
  const go = (e) => { e.preventDefault(); e.stopPropagation(); navigate(href(badge)); };
  if (small) {
    return (
      <span role="link" tabIndex={0} onClick={go} onKeyDown={(e) => e.key === 'Enter' && go(e)} title={`CTC independently reviewed · ${badge.ref}`}
        className="inline-flex items-center gap-1 text-[10px] font-bold text-emerald-800 bg-emerald-50 border border-emerald-300 px-2 py-0.5 rounded-full cursor-pointer hover:border-emerald-500" data-testid={testid}>
        <ShieldCheck className="w-3 h-3" /> CTC reviewed
      </span>
    );
  }
  return (
    <a href={href(badge)} onClick={go} data-testid={testid}
      className="inline-flex items-center gap-2 border border-emerald-300 bg-emerald-50 hover:border-emerald-500 rounded-full pl-2 pr-3 py-1 transition-colors">
      <ShieldCheck className="w-4 h-4 text-emerald-700" />
      <span className="text-xs font-bold text-emerald-900">CTC independently reviewed</span>
      <span className={`w-2 h-2 rounded-full ${dot}`} />
      <span className="text-[11px] font-mono text-emerald-800">{badge.ref}</span>
    </a>
  );
}
